export default __webpack_public_path__ + "static/media/mc_symbol.b720e3b5.svg";